import $ from 'jquery';

const $sidebar = $( '.js-sticky-sidebar' );
const $stickyArea = $( '.js-sticky-sidebar-area' );
const stickyOffset = $sidebar.data( 'sticky-offset' );

if ( $sidebar.length ) {
	$( window ).on( 'load', function() {
		let stickyAreaHeight = 0;

		$stickyArea.each( function() {
			stickyAreaHeight = stickyAreaHeight + $( this ).innerHeight();
		} );

		stickyAreaHeight = stickyAreaHeight - stickyOffset;

		$sidebar.css( 'height', stickyAreaHeight );
	} );
}
